document.addEventListener("DOMContentLoaded", function () {
  const html = document.querySelector("html");
  
  if (html.classList.contains("index")) {
    const header = document.querySelector(".header");
    const main = document.querySelector("main");

    // Default styles
    header.style.position = "fixed";
    header.style.zIndex = "1";
    header.style.width = "100vw";
    
    const updateHeaderStyle = () => {
        if (window.scrollY < 50) {
            header.style.background = "transparent";
            main.style.marginTop = "0"
        } else {
            header.style.background = "";
            main.style.marginTop = "0";
        }
    }

    window.addEventListener("scroll", updateHeaderStyle);
    updateHeaderStyle(); // Run initially in case page loads at a scrolled position
  }
});
